import React from "react";
import { useState } from "react";
import { useAddNoteMutation } from "../../../services/ticket.api.ts";
import './AddNotePopup.css'

const AddNotePopup = ({ ticketId, onClose }) => {
    const [addNote] = useAddNoteMutation();
    const [noteBody, setNoteBody] = useState('');
    const [isVisibleToClient, setIsVisibleToClient] = useState(false);
  
    const handleAddNote = async () => {
      try {
        await addNote({
          ticket_id: Number(ticketId),
          note_body: noteBody,
          is_visible_to_client: isVisibleToClient ? 1 : 0,
        }).unwrap();
        
        onClose();
      } catch (err) {
        console.error("Failed to add note:", err);
      }
    };
  
    return (
      <div className="note-popup-overlay" onClick={onClose}>
        <div 
          className="note-popup-container" 
          onClick={(e) => e.stopPropagation()}
        >
          <div className="note-popup-header">
            <h2>Add Note</h2>
            <button className="note-popup-close" onClick={onClose}>
              &times;
            </button>
          </div>
  
          <textarea
            className="note-popup-textarea"
            value={noteBody}
            onChange={(e) => setNoteBody(e.target.value)}
            placeholder="Enter your note here..."
          />
  
          <div className="note-popup-checkbox-container">
            <input 
              type="checkbox"
              id="client-visible"
              checked={isVisibleToClient}
              onChange={(e) => setIsVisibleToClient(e.target.checked)}
            />
            <label htmlFor="client-visible">Visible to Client</label>
          </div>
  
          <div className="note-popup-actions">
            <button 
              className="note-popup-button note-popup-button-cancel"
              onClick={onClose}
            >
              Cancel
            </button>
            <button 
              className="note-popup-button note-popup-button-submit"
              onClick={handleAddNote}
              disabled={!noteBody.trim()}
            >
              Add Note
            </button>
          </div>
        </div>
      </div>
    );
  };

export default AddNotePopup